import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { ValuesList } from '../../components/about/ValuesList';
import { PhilosophyGrid } from '../../components/about/PhilosophyGrid';
import { InitiativesGrid } from '../../components/about/InitiativesGrid';
import { EnquirySection } from '../../components/forms/EnquirySection';
import { aboutImages, aboutMission, aboutStory } from '../../data/aboutPage';
export function AboutESWorld() {
  usePageMeta('Who We Are | ES World', 'Founded in Dubai in 2016, ES World welcomes students from 106+ nationalities. Meet our team, our story and our values.');
  return <>
      <section className="w-full bg-white p-2 md:p-4" aria-labelledby="about-title" data-id="element-914" data-mp="aezve1seh2g5">
        <h1 id="about-title" className="sr-only" data-id="element-915" data-mp="fcrv3hzadsuw">
          Who we are: ES World
        </h1>
        <div className="relative h-[52svh] min-h-[360px] overflow-hidden rounded-[28px] bg-ink md:h-[72svh] md:rounded-[40px]" data-id="element-916" data-mp="1335hosz3qzi3">
          <img src={aboutImages.team} alt="The ES World team together at the 10th anniversary awards night" className="h-full w-full object-cover object-center" data-id="element-917" data-mp="17wqcyd9b9fdl" />
        </div>
      </section>

      <section className="w-full bg-white" aria-label="Our mission" data-id="element-918" data-mp="1i87ytrss5tkj">
        <figure className="mx-auto max-w-4xl px-5 py-16 md:px-8 md:py-24" data-id="element-919" data-mp="1x00fc74b9dnu">
          <span className="block type-h3 text-brand" aria-hidden="true" data-id="element-920" data-mp="1s7yxm5odiuqf">
            //
          </span>
          <blockquote className="mt-2 text-center type-h4 text-ink" data-id="element-921" data-mp="25z3x97rqrn0r">{aboutMission}</blockquote>
          <span className="mt-2 block text-right type-h3 text-brand" aria-hidden="true" data-id="element-922" data-mp="211lmdbu5yxq4">
            ///
          </span>
        </figure>
      </section>

      <section className="w-full bg-white" aria-labelledby="story-title" data-id="element-923" data-mp="2fw07bhxagh7f">
        <div className="mx-auto grid max-w-content gap-10 px-5 pb-16 md:px-8 md:pb-24 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-924" data-mp="2azjalzc0wuiq">
          <div data-id="element-925" data-mp="llwlr21mxrjb">
            <h2 id="story-title" data-id="element-926" data-mp="gl8k7mfs5sau">
              <span className="block type-h2-light text-ink" data-id="element-927" data-mp="gm0gz0l45w2p">Our story</span>
              <span className="block type-h2 text-brand" data-id="element-928" data-mp="169mcmbu1kdzt">ES World</span>
            </h2>
            {aboutStory.map(paragraph => <p key={paragraph.slice(0, 24)} className="mt-5 type-body text-ink" data-id="element-929" data-mp="1ab7y2lkn60lm">
                {paragraph}
              </p>)}
          </div>
          <img src={aboutImages.founders} alt="Founders Montserrat Taylor and Daniel Rodriguez looking at a laptop together" className="aspect-square w-full rounded-[28px] object-cover md:rounded-[40px]" data-id="element-930" data-mp="1k9f0lze6og43" />
        </div>
      </section>

      <section className="w-full bg-gradient-to-b from-white from-10% to-ink to-90%" aria-label="Meet our team" data-id="element-931" data-mp="1y0aclkjzbdbw">
        <div className="mx-auto max-w-content px-5 pb-8 md:px-8" data-id="element-932" data-mp="22z3s1iitteep">
          <img src={aboutImages.staff} alt="Portraits of ES World team members" className="w-full object-contain" loading="lazy" data-id="element-933" data-mp="231hjlheas8hi" />
        </div>
      </section>

      <ValuesList data-id="element-934" data-mp="2cym9nsb9ko3l" />
      <PhilosophyGrid data-id="element-935" data-mp="2cy2om2qbhjlc" />
      <InitiativesGrid data-id="element-936" data-mp="2cv6s8iu4b2z0" />

      <EnquirySection bg="grey" title="Talk with our team" description="Ask us anything about ES World, our courses or our campuses. We reply by email, and by WhatsApp if you add your number." submitLabel="Send my question" data-id="element-937" data-mp="19xu4k90lyar" />
    </>;
}